import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Axios from 'axios';
import PrivaciesView from './PrivaciesView';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      routes: []
    }
  }
  render() {
    return (
      <div className="App">
        <div style={{position: 'fixed', width: '100%', background: '#ffffff', top: 0}}><img style={{maxWidth: 200}} src="https://s3.amazonaws.com/movidesk-files/28B5A93D6327318B880260D9F5326B5C" /></div>
        <div>
          <PrivaciesView />
        </div>
      </div>
    );
  }
}

export default App;
